import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";

export interface PrioritizeExperimentalLabellingActionMessage {
    folderId: string;
    mailboxInfo: MailboxInfo;
    runName: string;
}

export const prioritizeExperimentalLabellingAction: (folderId: string, mailboxInfo: MailboxInfo, runName: string) => PrioritizeExperimentalLabellingActionMessage = action("prioritizeExperimentalLabellingAction", (folderId: string, mailboxInfo: MailboxInfo, runName: string): PrioritizeExperimentalLabellingActionMessage => ({
    folderId,
    mailboxInfo,
    runName,
}));
